<template>
  <div
    @click="collapsable ? $emit('collapse') : ''"
    class="nettdoc-section-header"
    :class="[dark ? 'nettdoc-dark' : '', height > 90 ? 'big-height' : '', big ? 'nettdoc-big' : '']"
    :style="img && img.length > 0 ? 'display: grid;grid-template-columns:74px auto' : ''"
  >
    <img
      v-if="img && img.length > 0"
      class="nettdoc-section-header__image"
      :class="img.includes('illu-card-beschwerden') ? 'nettdoc-section-header__image--bordered' : ''"
      :src="require('../assets/'+img+'.svg')"
      :alt="alt || 'No Description'"
      style="float:left"
    />
    <div>
      <template v-if="spanText && spanText !== ''">
        <p>
          <span>{{ text }}</span>
          <span :style="img ? 'font-weight:normal;' : 'opacity:0.3'"> {{ $t(spanText) }}</span>
        </p>
      </template>
      <template v-else>
        <p>
          {{ $t(text) }}
        </p>
      </template>
    <template v-if="!printView">
        <span v-if="required" style="float:right;color:var(--dark-peach)">*</span>
        <template v-if="showCollapsable">
          <span v-if="collapsable && collapsed" class="nettdoc-section-header__collapse redpen">
              <img @click="$emit('edit', name)" class="nettdoc-section-header__collapse--empty" src="../assets/icon-basis-ic-pen.svg" alt="pen for edit" style="cursor:pointer;"/>
          </span>
          <span v-if="collapsable" class="nettdoc-section-header__collapse">
            <img v-if="collapsed" class="nettdoc-section-header__collapse--arrow" src="../assets/icon-small-arrow-up.svg" alt="dropdown arrow up" />
            <img v-else class="nettdoc-section-header__collapse--arrow" src="../assets/icon-small-arrow-down.svg" alt="dropdown arrow down" />
          </span>
        </template>
        <template v-else>
          <span v-if="collapsable" class="nettdoc-section-header__collapse">
            <img v-if="complete" class="nettdoc-section-header__collapse--complete" src="../assets/check.svg" alt="green check for complete" />
            <img v-else class="nettdoc-section-header__collapse--empty" src="../assets/empty.svg" alt="grey pen for incomplete" />
          </span>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionHeader",
  data() {
    return {
      height: null
    }
  },
  props: {
    name: String,
    img: String,
    alt: String,
    text: String,
    spanText: String,
    required: Boolean,
    collapsable: Boolean,
    showCollapsable: Boolean,
    collapsed: Boolean,
    dark: Boolean,
    complete: Boolean,
    big: Boolean,
    printView: Boolean
  }
};
</script>

<style lang="scss" scoped>
.nettdoc-section-header {
  position: relative;
  box-sizing: border-box;
  padding: 0 16px;
  background-color: var(--pale-grey);
  text-align: left;
  min-height: 68px;
  line-height: 68px;
  border-top: 1px solid var(--light-sky-blue);
  color: var(--charcoal-grey);
  font-size: 20px;
  font-weight: 600;
  &__image {
    margin-top: 8px;
    width: 52px;
    height: 52px;
    &--bordered {
      border-radius: 100%;
      border: 2px solid var(--light-sky-blue);
    }
  }
  div {
    display: grid;
    grid-template-columns: auto max-content max-content;
    height: 67px;
    top: 0;
    width: 100%;
    box-sizing: border-box;
  }
  span {
    font-size: 16px;
    line-height: normal;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-self: center;
  }
  p {
    align-self: center;
    line-height: normal;
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    overflow: auto;
    text-overflow: ellipsis;
  }
  &__collapse {
    float: right;
    line-height: 68px;
    &--empty {
      width: 24px;
      height: 24px;
    }
    &--complete {
      width: 16px;
      height: 16px;
    }
    &--arrow {
      width: 16px;
      height: 16px;
    }
  }
  .redpen {
    position: absolute;
    right: 60px;
  }
}
.nettdoc-dark {
  background-color: var(--very-light-blue);
  min-height: 50px;
  line-height: 50px;
  padding: 0 16px;
  text-align: left;
  span {
    font-size: 16px !important;
  }
  p {
    font-size: 16px !important;
  }
  &__collapse {
    line-height: 50px;
  }
}
.nettdoc-big {
  min-height: 68px;
  line-height: 68px;
  span {
    font-size: 20px !important;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: unset !important;
  }
  p {
    margin: 0;
    font-size: 20px !important;
    font-weight: 600;
  }
  &__collapse {
    float: right;
    line-height: 68px;
    &--empty {
      width: 24px;
      height: 24px;
    }
    &--complete {
      width: 16px;
      height: 16px;
    }
    &--arrow {
      width: 16px;
      height: 16px;
    }
  }
}
</style>